import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { ChartActionStrip } from "../../../../../../../components/app/provider/patient/chart";
import { useReduceDisclosure } from "../../../../../../../hooks/use-reduce-disclosure";
import StartNewAssessmentDrawer from "../../../../scheduling/appointment/encounter/new-assessment/StartNewAssessmentDrawer";
import SendPatientAssementFormsModal from "./PatientAssementForms/SendPatientAssementFormsModal";
import AssessmentSummaryGraph from "./summary/AssessmentSummaryGraph";

const PatientChartAssessment = () => {
  const currentActiveTab = location.pathname.split("/")?.[7] as string;

  const [sendAssessmentFormsDisclosure, startNewAssessmentDisclosure] =
    useReduceDisclosure(2);

  const [_isNewScreeningView, setIsNewScreeningView] = useState(
    currentActiveTab === "start-new"
  );

  const [activeTab, setActiveTab] = useState<string>("");

  useEffect(() => {
    setActiveTab(
      currentActiveTab === "assessment" ? "" : (currentActiveTab ?? "")
    );
  }, [currentActiveTab]);

  const isVisitNotePage = window.location.pathname.includes("/visit-note");

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SendPatientAssementFormsModal
        disclosureHost={sendAssessmentFormsDisclosure}
      />
      <StartNewAssessmentDrawer disclosureHost={startNewAssessmentDisclosure} />

      {!isVisitNotePage && (
        <ChartActionStrip
          endContent={
            <>
              <ChartActionStrip.Button
                startIcon={<AddIcon />}
                onClick={() => startNewAssessmentDisclosure.open()}
              >
                New Screening Assessment
              </ChartActionStrip.Button>
              <ChartActionStrip.Button
                variant="outlined"
                onClick={() => sendAssessmentFormsDisclosure.open()}
              >
                Send Assessments
              </ChartActionStrip.Button>
            </>
          }
        />
      )}

      <Box sx={{ flex: 1, overflow: "scroll" }}>
        {isVisitNotePage && activeTab ? (
          <Box p={1}>
            <AssessmentSummaryGraph />
          </Box>
        ) : (
          <Outlet context={{ setIsNewScreeningView }} />
        )}
      </Box>
    </Box>
  );
};

export default PatientChartAssessment;
